module.exports = __webpack_public_path__ + "img/case.c9f91d61.png";